// Required by src/engines/frontend_core/angular/customer_application_bootstrap/angular/directives.js
// All new directives must be required manually here.

angular.module('avant.customer_applications.directives', []);
// Amount components
require('./amountBanner');
require('./amountComponentMenu');
require('./amountHeader');
require('./amountHeader2');
require('./amountHeaderDrawer');
require('./amountProgressTracker');

// Amount directives
require('./amountAutofill.js');
require('./amountClearIrrelevantData.coffee');
require('./amountDateInput.coffee');
require('./amountDisabled.coffee');
require('./amountEmailMask.coffee');
require('./amountFocusOnFirstError.coffee');
require('./amountFormInit.coffee');
require('./amountHideInputWrappers.coffee');
require('./amountIcon.coffee');
require('./amountInlineSpinner.coffee');
require('./amountLoadingSpinner.coffee');
require('./amountLoanAmountSelector.coffee');
require('./amountLoanAmountSelectorDropdown.coffee');
require('./amountModal.coffee');
require('./amountPromo.coffee');
require('./amountSsnMask.coffee');
require('./amountToggleDescribedby.coffee');
require('./amountTooltip.coffee');
require('./amountTrapFocus.coffee');
require('./amountValidation.coffee');

// Avant directives
require('./appField.coffee');
require('./bindBgImg.coffee');
require('./broadcastScroll.coffee');
require('./capitalize.coffee');
require('./customValidation.coffee');
require('./declinePartner.coffee');
require('./declinePartnerDisclaimer.coffee');
require('./formAutofillFix.coffee');
require('./genericReassurance.coffee');
require('./maskedInput.coffee');
require('./mobileCompactHide.coffee');
require('./navCustomerApplication.coffee');
require('./popover.coffee');
require('./progressBar.coffee');
require('./regexRestrict.coffee');
require('./sectionButton.coffee');
require('./setFormAutocomplete.coffee');
require('./showInArray.coffee');
require('./singleFieldFocus.coffee');
require('./toggleProductTypeByState.coffee');
require('./ukPostcode.coffee');
